export default __webpack_public_path__ + "static/media/reward.73964cff.png";